import { render } from "./PredictionMarkets.vue?vue&type=template&id=54cd0d4d&scoped=true"
import script from "./PredictionMarkets.vue?vue&type=script&lang=js"
export * from "./PredictionMarkets.vue?vue&type=script&lang=js"

import "./PredictionMarkets.vue?vue&type=style&index=0&id=54cd0d4d&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cd0d4d"],['__file',"resources/js/components/PredictionMarkets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54cd0d4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54cd0d4d', __exports__)) {
    api.reload('54cd0d4d', __exports__)
  }
  
  module.hot.accept("./PredictionMarkets.vue?vue&type=template&id=54cd0d4d&scoped=true", () => {
    api.rerender('54cd0d4d', render)
  })

}


export default __exports__